import Class from "@/Class";
import DetailViewContext from "@/ViewModels/Contexts/DetailViewContext";
import { IDetailViewGroupDTO } from "coreframetypings/dto";

type Changes = {
    detailViewItems: string[];
    properties: string[];
}

export default class WizardChangeTracker extends Class {
    private changes: Changes;
    private allDetailViewItems: string[];

    constructor(private context: DetailViewContext, private group: IDetailViewGroupDTO) {
        super();

        this.undisposeProperties.push('context', 'detailViewGroup');

        this.allDetailViewItems = this.getDetailViewItemNamesFromGroupRecursive(this.group);

        this.context.addOnAfterApplyInterceptor(() => {
            this.changes = {
                detailViewItems: [],
                properties: [],
            };
        });

        this.changes = {
            // Bei neuen Objekten behandeln wir erst einmal alle Items als geändert
            detailViewItems: this.context.detailViewContextDTO.isNewObject ? this.allDetailViewItems : [],
            properties: [],
        };
    }

    public track(): void {
        this.context.genericObject.onChange((prop, _) => {
            // Der Hook kann auch während des Aufbaus einer DV gefeuert werden.
            // Wir wollen aber nur auf Änderungen durch den Benutzer reagieren.
            if (!this.context.isDetailViewReady())
                return;

            const dotIndex = prop.indexOf('.');
            const detailViewItem = dotIndex >= 0 ? prop.substring(0, dotIndex) : prop;
            if (!this.allDetailViewItems.includes(detailViewItem))
                return;

            if (!this.changes.detailViewItems.includes(detailViewItem))
                this.changes.detailViewItems.push(detailViewItem);

            if (!this.changes.properties.includes(prop))
                this.changes.properties.push(prop);
        }, null, this, true);
    }

    public getChanges(): Changes {
        const changedDetailViewItems = this.allDetailViewItems.filter(p => this.changes.detailViewItems.includes(p));
        const changedProperties = changedDetailViewItems.filter(i => this.changes.properties.filter(p => p === i || p.includes(".") && p.startsWith(i)));
        return {
            detailViewItems: changedDetailViewItems,
            properties: changedProperties,
        };
    }

    public remove(changes: Changes): void {
        this.changes.detailViewItems = this.changes.detailViewItems.filter(i => !changes.detailViewItems.includes(i));
        this.changes.properties = this.changes.properties.filter(p => !changes.properties.includes(p));
    }

    private getDetailViewItemNamesFromGroupRecursive(group: IDetailViewGroupDTO): string[] {
        let result: string[] = [];
        for (let i = 0; i < group.items?.length; i++) {
            let item = group.items[i];
            result.push(item.name);
        }
        for (let j = 0; j < group.detailViewGroups?.length; j++) {
            let innerGroup = group.detailViewGroups[j];
            if (innerGroup.uiGenerator.indexOf('WizardGroup') === -1) {
                result = _.union(result, this.getDetailViewItemNamesFromGroupRecursive(innerGroup));
            }
        }
        return result;
    }
}